// 文件编码: UTF-8
// 说明：本文件包含中文注释，需确保以 UTF-8 编码保存
/**
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
	const { currentUser } = initialState ?? {};

	return {
		canAdmin: !!currentUser
	};
}
